var lists_default = {
  "fontElementMap": "_9jRXV",
  "orderedlist": "Meaia",
  "bulletedlist": "_2zbP6",
  "listItem": "mMgeF"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
